import api from "@/app/_module/services/api";
import { getApiUrl } from "@/app/_module/services/config";
import { endpoint } from "@/app/_module/services/endpoints";

export interface CallScript {
  id: string;
  userId: string;
  agencyId?: string;
  name: string;
  content: string;
  category: string;
  productType?: string;
  isDefault: boolean;
  isTemplate: boolean;
  sortOrder: number;
  createdAt: string;
  updatedAt: string;
}

export const scriptService = {
  getScripts: async (): Promise<CallScript[]> => {
    const response = await api.get({
      url: getApiUrl(endpoint.callScripts.list),
      auth: true,
    });
    return (response.data as any)?.data || [];
  },

  getScript: async (id: string): Promise<CallScript> => {
    const response = await api.get({
      url: getApiUrl(endpoint.callScripts.detail(id)),
      auth: true,
    });
    return (response.data as any)?.data;
  },

  createScript: async (data: {
    name: string;
    content: string;
    category?: string;
    productType?: string;
    isDefault?: boolean;
    shareWithAgency?: boolean;
    scope?: string;
  }): Promise<CallScript> => {
    const response = await api.post({
      url: getApiUrl(endpoint.callScripts.list),
      body: data,
      auth: true,
    });
    return (response.data as any)?.data;
  },

  updateScript: async (
    id: string,
    data: { name?: string; content?: string; category?: string; isDefault?: boolean; shareWithAgency?: boolean; scope?: string },
  ): Promise<CallScript> => {
    const response = await api.put({
      url: getApiUrl(endpoint.callScripts.detail(id)),
      body: data,
      auth: true,
    });
    return (response.data as any)?.data;
  },

  deleteScript: async (id: string): Promise<void> => {
    await api.delete({
      url: getApiUrl(endpoint.callScripts.detail(id)),
      auth: true,
    });
  },

  rewriteScript: async (id: string, leadData?: Record<string, any>): Promise<string> => {
    const response = await api.post({
      url: getApiUrl(endpoint.callScripts.rewrite(id)),
      body: { leadData },
      auth: true,
    });
    return (response.data as any)?.data?.rewrittenContent || "";
  },

  generateScript: async (leadData?: Record<string, any>, scriptType?: string, callPhase?: string): Promise<string> => {
    const response = await api.post({
      url: getApiUrl(endpoint.callScripts.generate),
      body: { leadData, scriptType, callPhase },
      auth: true,
    });
    return (response.data as any)?.data?.content || "";
  },

  duplicateTemplate: async (id: string): Promise<CallScript> => {
    const response = await api.post({
      url: getApiUrl(`/call-scripts/${id}/duplicate`),
      auth: true,
    });
    return (response.data as any)?.data;
  },
};
